import { useState } from "react";

export const useResetSignal = () => {
  const [resetSignal, setResetSignal] = useState(0);
  const sendResetSignal = () => setResetSignal((prev) => prev + 1);

  return { resetSignal, sendResetSignal };
};
